// extracted by mini-css-extract-plugin
module.exports = {"a":"block-a_a__1r79U","a2":"block-a_a2__1s_kc"};